import { render } from "./addInventory.vue?vue&type=template&id=7f1004fd&scoped=true"
import script from "./addInventory.vue?vue&type=script&lang=js"
export * from "./addInventory.vue?vue&type=script&lang=js"

import "./addInventory.vue?vue&type=style&index=0&id=7f1004fd&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1004fd"]])

export default __exports__